/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {

    /**
     * Object to manage data contained within a Country-State Select component.
     */
    Alpine.data('countryStateSelect', (selectedCountry, selectedState, stateOptions, initialSelectedState, stateSelectId) => ({

        /**
         * @var String|null The model value of the selected country.
         */
        selectedCountry: selectedCountry,

        /**
         * @var String|null The model value of the selected state.
         */
        selectedState: selectedState,

        /**
         * @var Array The list with available states.
         */
        stateOptions: stateOptions,

        /**
         * @var String Identifier in DOM of the Select element of the state.
         */
        stateSelectId: stateSelectId,

        /**
         * @var Bool The flag to determinate what type of state input should be: the select or the text input.
         */
        isStateOfTextType: true,

        /**
         * @var Array The array of the states according to the selected country.
         */
        get countryStateOptions() {
            const groupedCountries = this.stateOptions.filter(
                (option) => option.group && this.selectedCountry && option.group.toLowerCase() === this.selectedCountry.toLowerCase()
            );

            if (!groupedCountries.length) {
                return [];
            }

            const options = groupedCountries.map(option => ({
                text: option.display,
                value: option.value,
                selected: this.selectedState === option.value,
                display: true,
            }));

            options.unshift({
                text: '',
                value: '',
                display: false,
            });

            return options;
        },

       /**
        * @var Bool The getter flag to determine if the country field has selected value.
        */
        get hasCountrySelected() {
          return this.selectedCountry && this.selectedCountry !== '';
        },

        /**
         * Initialization.
         */
        init() {
            this.$watch('selectedCountry', (value) => {
                if (value === undefined) {
                   return;
                }

                this.initStateType();
                Livewire.dispatch(`refreshSelect${this.stateSelectId}`, {options: this.countryStateOptions});
            });

            this.initStateType();
        },

        /**
         * The handler of the country select.
         *
         * @param {Event} event
         */
        handleCountrySelectChange(event) {
            if (!event.target.value) {
                this.clearSelectedState();
            }
            this.selectedCountry = event.detail;
            this.selectedState = '';
        },

        /**
         * Initialize type of the input element for the state.
         */
        initStateType() {
            this.isStateOfTextType = !this.countryStateOptions.length;
        },

        /**
         * Initialize the value of the selected state.
         */
        clearSelectedState() {
            if (this.selectedState) {
                this.selectedState = '';
            }
        }
    }));
});
